import { useEffect, useState } from "react";

export default function Countdown({ target, large = false, testId = "drop-countdown" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const diff = Math.max(0, new Date(target).getTime() - now);
  if (diff <= 0) {
    return (
      <p className={`${large ? "mt-8" : "mt-6"} font-mono text-[11px] tracking-[0.35em] text-white`} data-testid={testId}>
        DROPPING SOON — STAY READY
      </p>
    );
  }
  const units = [
    ["DAYS", Math.floor(diff / 86400000)],
    ["HRS", Math.floor(diff / 3600000) % 24],
    ["MIN", Math.floor(diff / 60000) % 60],
    ["SEC", Math.floor(diff / 1000) % 60],
  ];
  return (
    <div className={`${large ? "mt-8" : "mt-6"} flex gap-2 sm:gap-3`} data-testid={testId}>
      {units.map(([label, value]) => (
        <div key={label} className={`min-w-0 flex-1 border border-wire text-center ${large ? "px-1 py-4 sm:px-3 sm:py-5" : "px-2 py-3"}`}>
          <p className={`font-display font-extrabold text-white ${large ? "text-2xl sm:text-5xl" : "text-xl"}`}>
            {String(value).padStart(2, "0")}
          </p>
          <p className={`mt-1 font-mono tracking-[0.3em] text-neutral-500 ${large ? "text-[9px]" : "text-[8px]"}`}>{label}</p>
        </div>
      ))}
    </div>
  );
}
